/**
 * Audit log API endpoints
 */

import { fetchApi } from '../core';
import type { AuditEventListResponse, AuditLogQueryParams } from '../types';

function buildAuditQuery(params: AuditLogQueryParams = {}): string {
  const search = new URLSearchParams();
  if (params.tenant_id) search.set('tenant_id', params.tenant_id);
  if (params.actor_user_id) search.set('actor_user_id', params.actor_user_id);
  if (params.event_type) search.set('event_type', params.event_type);
  if (params.event_prefix) search.set('event_prefix', params.event_prefix);
  if (params.target_type) search.set('target_type', params.target_type);
  if (params.target_id) search.set('target_id', params.target_id);
  if (typeof params.after_ms === 'number') search.set('after_ms', String(params.after_ms));
  if (typeof params.before_ms === 'number') search.set('before_ms', String(params.before_ms));
  if (typeof params.page === 'number') search.set('page', String(params.page));
  if (typeof params.limit === 'number') search.set('limit', String(params.limit));
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export function listTenantAuditEvents(
  params: AuditLogQueryParams = {},
  componentName: string = 'Unknown'
) {
  return fetchApi<AuditEventListResponse>(
    `/audit-events${buildAuditQuery(params)}`,
    {},
    componentName
  );
}

export function listPlatformAuditEvents(
  params: AuditLogQueryParams = {},
  componentName: string = 'Unknown'
) {
  return fetchApi<AuditEventListResponse>(
    `/platform/audit-events${buildAuditQuery(params)}`,
    {},
    componentName
  );
}
